import { useAuthenticatedUserQuery } from 'modules/auth/queries/useAuthenticatedUserQuery'
import { useCorporateTDAEInformationQuery } from 'modules/services/queries/useCorporateTDAEInformationQuery'
import { useCallback } from 'react'

export const useFetchTDAEInformation = () => {
  const {
    data: user,
    isLoading: isUserLoading,
    isError: isUserError,
    refetch: refetchUser,
  } = useAuthenticatedUserQuery()

  const {
    data: tdaeInformation,
    isLoading: isTDAEInformationLoading,
    isError: isTDAEInformationError,
    refetch: refetchTDAEInformation,
    error: tdaeInformationError,
  } = useCorporateTDAEInformationQuery(user?.corporateId, {
    retry: false,
  })

  const isFetchTDAEInformationLoading =
    isUserLoading || isTDAEInformationLoading

  const isFetchTDAEInformationError = isUserError || isTDAEInformationError

  const errorRefetch = useCallback(() => {
    if (isUserError) {
      refetchUser()
    }
    if (isTDAEInformationError) {
      refetchTDAEInformation()
    }
  }, [isUserError, isTDAEInformationError, refetchUser, refetchTDAEInformation])

  return {
    isFetchTDAEInformationLoading,
    isFetchTDAEInformationError,
    tdaeInformation,
    tdaeInformationError,
    errorRefetch,
  }
}
